import { action } from 'satcheljs';

/**
 * This will remove the passed arialabel if existant from the list of Arialabels which are to be listened by the screenreader
 * Consumer components which want themselves to be registered to listen and read the changes in them by the screen reader
 * must use this function/action in componentWillUnmountMount for cleanup
 * @param ariaLiveLabel The localised change string which needs to be removed by the consuming component on the latter's closure
 */
export default action('removeAriaLiveLabel', function removeAriaLiveLabel(ariaLiveLabel: string): {
    ariaLiveLabel: string;
} {
    return { ariaLiveLabel };
});
